import { HttpService } from '@/shared/services'
import { ApprovalRequest } from '../models/ApprovalRequest'
import { ApprovalRequestStep } from '../models/ApprovalRequestStep'
import GetRequestStepsInputDto from './interfaces/GetRequestStepsInputDto'
import { CreateRequestResolutionInputDto } from './interfaces/CreateRequestResolutionInputDto'
import RequestDetail from '../models/ApprovalRequestDetail'

const http = new HttpService()

export const getRequestByApproverId = async (approverId: string) => {
  const response = await http.get<ApprovalRequest[]>(
    `approvalRequest/employee/${approverId}`
  )
  return response.data
}

export const getApprovalFlowStepsByRequest = async (
  inpuDto: GetRequestStepsInputDto
) => {
  const response = await http.post<
    GetRequestStepsInputDto,
    ApprovalRequestStep[]
  >('approvalRequest/steps', inpuDto)

  return response.data
}

export const createRequestResolution = async (
  dto: CreateRequestResolutionInputDto,
  areBackup: boolean
) => {
  let response = null

  if (areBackup === false) {
    response = await http.post<CreateRequestResolutionInputDto, string>(
      'approvalRequest/resolution',
      dto
    )
  } else {
    response = await http.post<CreateRequestResolutionInputDto, string>(
      'approvalRequest/backup/resolution',
      dto
    )
  }

  return response.data
}

export const getAllPendingRequests = async () => {
  const response = await http.get<ApprovalRequest[]>(
    `approvalRequest/approver/pending`
  )
  return response.data
}

export const getAllRequests = async () => {
  const response = await http.get<ApprovalRequest[]>(
    `approvalRequest/approver/all`
  )
  return response.data
}

export const getPendingBackupRequests = async () => {
  const response = await http.get<ApprovalRequest[]>(`approvalRequest/backup`)
  return response?.data
}

export const getRequestDetail = async (requestId: string) => {
  const response = await http.get<RequestDetail>(
    `approvalRequest/detail/${requestId}`
  )
  return response?.data
}
